import { useState, useEffect, useCallback } from "react";
import { searchLots } from "../api/searchLots";

export const useSearchLots = () => {
  const [filters, setFilters] = useState({
    page: 1,
    pageLimit: 10,

    text: "",
    amountFrom: "",
    amountTo: "",
    unitPriceFrom: "",
    unitPriceTo: "",
    number: "",

    dateStartFrom: null,
    dateStartTo: null,
    dateEndFrom: null,
    dateEndTo: null,

    tradeId: "",
    trades: [],

    regionCode: "",
    districtCode: "",
    localityCode: "",
    regionCodes: [],

    customerIdentifier: null,
    oked: [],

    padiFilterIds: [],
    subjectTypes: [],
    sources: [],
    extras: [],

    newVersion: true,
    getStatistics: true,
    onlyHiddenLots: false,
    onlyUnviewedLots: false,
    ApiV2: true,
  });

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const [hiddenData, setHiddenData] = useState(null);
  const [isHiddenLoading, setIsHiddenLoading] = useState(false);
  const [hiddenTotal, setHiddenTotal] = useState(0);

  const [easyData, setEasyData] = useState(null);
  const [easyLoading, setEasyLoading] = useState(false);
  const [easyTotal, setEasyTotal] = useState(0);

  const [similarData, setSimilarData] = useState(null);
  const [similarLoading, setSimilarLoading] = useState(false);
  const [similarTotal, setSimilarTotal] = useState(0);

  const prepareFilters = (f) => ({
    ...f,
    trades: f.trades?.map((t) => t.code),
    regionCodes: f.regionCodes?.map((r) => r.code),
    subjectTypes: f.subjectTypes?.map((s) => s.id),
    customerIdentifier: f.customerIdentifier ? [f.customerIdentifier.code] : [],
    oked: f.oked?.map((o) => o.code),
    padiFilterIds: f.padiFilterIds?.map((p) => p.id),
  });

  const fetchLots = useCallback(async () => {
    setIsLoading(true);

    try {
      const prepared = prepareFilters(filters);
      const res = await searchLots(prepared);

      setData(res);
      setTotal(res?.all ?? 0);
    } catch (err) {
      console.error("Ошибка загрузки лотов", err);
    } finally {
      setIsLoading(false);
    }
  }, [filters]);

  const fetchHiddenLots = useCallback(async () => {
    setIsHiddenLoading(true);
    try {
      const prepared = {
        ...prepareFilters(filters),
        onlyHiddenLots: true,
        newVersion: true,
        getStatistics: true,
      };

      const res = await searchLots(prepared);

      setHiddenData(res ?? {});
      setHiddenTotal(res?.all ?? 0);
    } catch (err) {
      console.error("Ошибка загрузки скрытых лотов", err);
    } finally {
      setIsHiddenLoading(false);
    }
  }, [filters]);

  const fetchEasyLots = useCallback(async () => {
    setEasyLoading(true);
    try {
      const prepared = {
        ...prepareFilters(filters),
        OnlyEasyLots: true,
        getStatistics: true,
      };

      const res = await searchLots(prepared);

      setEasyData(res ?? {});
      setEasyTotal(res?.all ?? 0);
    } catch (err) {
      console.error("Ошибка загрузки лёгких лотов:", err);
    } finally {
      setEasyLoading(false);
    }
  }, [filters]);

  const fetchSimilarLots = useCallback(async () => {
    setSimilarLoading(true);
    try {
      const prepared = {
        ...prepareFilters(filters),
        OnlyUserItems: true,
        getStatistics: true,
      };

      const res = await searchLots(prepared);

      setSimilarData(res ?? {});
      setSimilarTotal(res?.all ?? 0);
    } catch (err) {
      console.error("Ошибка загрузки похожих лотов:", err);
    } finally {
      setSimilarLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchLots();
    fetchHiddenLots();
    fetchEasyLots();
    fetchSimilarLots();
  }, [fetchLots, fetchHiddenLots, fetchEasyLots, fetchSimilarLots]);

  return {
    data,
    hiddenData,
    total,
    hiddenTotal,
    isLoading,
    isHiddenLoading,
    easyData,
    easyLoading,
    easyTotal,
    fetchEasyLots,

    similarData,
    similarLoading,
    similarTotal,
    fetchSimilarLots,

    filters,
    setFilters,

    page: filters.page,
    setPage: (page) => setFilters((prev) => ({ ...prev, page })),

    pageLimit: filters.pageLimit,
    setPageLimit: (limit) =>
      setFilters((prev) => ({
        ...prev,
        pageLimit: limit,
        page: 1,
      })),
  };
};
